import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, NgForm, Validators, FormControl } from '@angular/forms';
import { HttpClient, HttpParams} from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { SettingService } from 'src/app/_services/setting.service';
import _ from 'lodash';
@Component({
  selector: 'app-update-locator',
  templateUrl: './update-locator.component.html',
  styleUrls: ['./update-locator.component.scss']
})
export class UpdateLocatorComponent implements OnInit {
  updateLocatorForm:UntypedFormGroup;
  projectName: any;
  submitted= false;
  url: string;
  title: any;
  projectId: any;
  parentTestDataId: any;
  locatorData: any;
  Index: any;
  locatorDataForUpdate: any;
  enableSubmitButton: boolean = false;
  constructor(@Inject(MAT_DIALOG_DATA) public data,
  private formBuilder: UntypedFormBuilder,
  private http: HttpClient,
  private toastrService:ToastrService,
  private setting: SettingService,
  public dialogRef: MatDialogRef< UpdateLocatorComponent>) { 

    //console.log(data.item);
    //console.log(data.index);
    this.locatorData = data.item;
    this.Index = data.index;
    this.locatorDataForUpdate = this.locatorData.locatorEntryMap.entry[this.Index]
    //console.log(this.locatorDataForUpdate);
  }
  ngOnInit() {
    this.loadForm();
  }


  loadForm(){
    this.updateLocatorForm = this.formBuilder.group({
      key:['',Validators.required],
      value:['',Validators.required]
    })
  }
  get f() { return this.updateLocatorForm.controls; }
  onUpdateLocator(){
    this.submitted = true;
    if(this. updateLocatorForm.invalid){
      return;
    }
    var objFormval = this.updateLocatorForm.value;

   //console.log(objFormval);
   
   this.locatorDataForUpdate = objFormval;
   //console.log(this.locatorDataForUpdate);
   this.locatorData.locatorEntryMap.entry[this.Index]=this.locatorDataForUpdate;
   //console.log(this.locatorData);
   var functionValue = _.omit(this.locatorData, ['alternateLocatorMap', 'coordinateMap', 'locatorEntryMapEdited','path']);
const compareKeyValue = functionValue.locatorEntryMap.entry.filter((f)=>f.key==objFormval.key);
//console.log(compareKeyValue);
if(compareKeyValue[1]){
    this.toastrService.clear();
    this.toastrService.warning('Sorry ! Duplicate keys Are Not Allowed '); 
return;
}

   this.projectId=functionValue.projectId;
   this.setting.editLocatorSuite(this.projectId,functionValue).subscribe(
    (data)=>
    {
      this.closeDialog();
      this.toastrService.clear();
      this.toastrService.success( 'Locator data updated succesfully'); 
     if(data['testCaseData']){
       var testCaseData = data['testCaseData'];
       var listAffectedTestCase = []
       for(let i =0; i< testCaseData.length;i++){
        listAffectedTestCase.push(testCaseData[i].title);
       }
      //console.log(listAffectedTestCase);
      this.toastrService.clear();
      this.toastrService.info(
        'Following Tasks are being affected : <br> <div> <ol > <li [innerHtml]="list">' +listAffectedTestCase + '</li></ol></div>' , null,  {
          enableHtml: true,
        
      } 
      )
    
     
     //  this.locatorValueData = data;
     }
     
    
    })
    
  }
  closeDialog() {
    this.dialogRef.close(false);
  }
  enableSubmit(value){
  //console.log(this.locatorDataForUpdate.key);
  //console.log(this.locatorDataForUpdate.value);
    if(value == this.locatorDataForUpdate.key || value == this.locatorDataForUpdate.value){
      this.enableSubmitButton = false;
      //console.log('equal')
    }
   else {
    this.enableSubmitButton = true;
   }
    //console.log(value);
    // this.enableSubmitButton = true;
  }
}
